exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".import-data-container[data-v-509652cd]{-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);position:absolute;top:40%;left:50%}.import-data[data-v-509652cd]{position:relative;width:1200px;padding:0 50px;overflow:hidden}.import-data .import-file[data-v-509652cd]{width:67px;margin:0;opacity:0;filter:alpha(opacity=0);-moz-opacity:0;cursor:pointer}.import-data .el-upload[data-v-509652cd]{display:inline-block}\n", ""]);

// exports
